export default "__VITE_ASSET__fed00fad__"